<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeFixProductsDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100">
        <!-- title -->
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL">
            {{ "fix-products.add" | translate }}
        </h4>
        <span class="text-center pb-4" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
            {{ "fix-products.explain" | translate }}
        </span>

        <div class="d-flex flex-grow-1 w-100 position-relative">
            <div class="position-absolute h-100 d-flex flex-column align-items-center flex-grow-1 w-100 gap-1 gap-lg-2 overflow-auto p-1 p-lg-2 zx-bg-gray-v-light-opacity rounded-2"
                [class.zx-border-gray-25-pr]="isDarkMode">
                <!-- product -->
                <section ngClass="d-flex w-100 row p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2 gap-2"
                    [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL"
                    *ngFor="let product of products; index as i" tabindex="0" role="button"
                    class="my-tab-focus d-flex w-100">
                    <!-- name and code -->
                    <span
                        class="zx-text-small zx-text-pink col-12 w-100 p-0 pt-lg-1 px-lg-2 d-flex align-items-center w-100 justify-content-between"
                        [class.text-start]="!isRTL" [class.zx-text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
                        <span [class.fw-bold]="!isDarkMode">
                            {{ "fix-product." + product.productId.name | translate }}
                        </span>
                        <div class="d-flex align-items-center gap-2 gap-lg-3">
                            <span>#{{ product.productId.code }}</span>
                            <div aria-label="Fix Products Explained"
                                [matTooltip]="'fix-products.serial-number' | translate" [matTooltipPosition]="'below'"
                                [matTooltipShowDelay]="0"
                                class="i-explain-icon svg c-pointer zx-small-icon-size p-1 m-0" style="background-image: url('/assets/images/i-explain-icon.svg');
                                                          background-repeat: no-repeat;
                                                          background-size: cover;
                                                          width: 24px;
                                                          height: 24px;" (click)="toggleTooltip(i)">
                            </div>
                        </div>
                    </span>
                    <!-- main content -->
                    <div class="p-0 px-lg-2 pb-lg-2 d-flex justify-content-between">
                        <div class="d-flex rounded-2 zx-big-icon-size zx-border-gray-v-light">
                            <img [src]="'assets/images/fix-products/' + product.productId.previewImage + '.png'"
                                [alt]="product.productId.name + ' Logo'" class="w-100 h-100 rounded-2">
                        </div>

                        <div class="d-flex flex-column justify-content-end align-items-center gap-1"
                            [class.text-white]="isDarkMode">
                            <!-- price per unit -->
                            <span class="zx-text-tiny">
                                <span>{{ "fix-products.price" | translate }}</span>
                                <span>:</span>
                                <span class="zx-100-opp">-</span>
                                <span>{{ product.price ? product.price : product.productId.defaultPrice }}</span>
                                <span class="zx-100-opp">.</span>
                                <span>{{ "printing-table.nis" | translate }}</span>
                            </span>
                            <!-- add/remove -->
                            <div class="d-flex align-items-center gap-1">
                                <button mat-icon-button (click)="changeNumberOfItems('remove', i)"
                                    [disabled]="products[i].numOfCopies === 0">
                                    <mat-icon>remove</mat-icon>
                                </button>
                                <input class="zx-copies-input" [class.zx-text-white-bg-transparent]="isDarkMode"
                                    [(ngModel)]="product.numOfCopies" matInput type="number" min="1">
                                <button mat-icon-button (click)="changeNumberOfItems('add', i)">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </div>
                            <!-- total price -->
                            <span *ngIf="products[i].numOfCopies === 0" class="zx-text-tiny zx-100-opp">.</span>
                            <span *ngIf="products[i].numOfCopies === 1" class="zx-text-tiny">
                                <span>{{ product.price ? product.price : product.productId.defaultPrice }}</span>
                                <span class="zx-100-opp">.</span>
                                <span>{{ "printing-table.nis" | translate }}</span>
                            </span>
                            <span *ngIf="products[i].numOfCopies > 1" class="zx-text-tiny d-flex align-items-center">
                                <span>{{ product.price ? product.price : product.productId.defaultPrice }}</span>
                                <span class="zx-100-opp">.</span>
                                <span class="zx-text-tiny-tiny">
                                    {{ "printing-table.nis" | translate }}
                                </span>
                                <span class="zx-100-opp">.</span>
                                <span>×</span>
                                <span class="zx-100-opp">.</span>
                                <span>{{ products[i].numOfCopies }}</span>
                                <span class="zx-100-opp">.</span>
                                <span class="zx-text-tiny-tiny">
                                    {{ "su-management.units.short" | translate }}
                                </span>
                                <span class="zx-100-opp">.</span>
                                <span>=</span>
                                <span class="zx-100-opp">.</span>
                                <span>{{ (product.price ? product.price : product.productId.defaultPrice) *
                                    products[i].numOfCopies }}</span>
                                <span>{{ "printing-table.nis" | translate }}</span>
                            </span>
                        </div>

                    </div>
                </section>
            </div>
        </div>


        <div class="d-flex flex-column gap-3 align-items-center w-100 pt-3">
            <button color="primary" mat-raised-button class="rounded-pill w-100 text-white"
                (click)="saveProductsAndcloseFixProductsDialog()">
                <span class="d-flex align-items-center justify-content-center">
                    <span>
                        {{ "error-content-ok-btn" | translate }}
                    </span>
                    <span class="d-flex align-items-center" *ngIf="totalOrderdFixProducts() > 0">
                        <span class="zx-100-opp">_</span>
                        <span>(</span>
                        <span *ngIf="totalOrderdFixProducts() === 1" class="zx-text-tiny">{{
                            "fix-products.num-of-products.one" | translate }}
                        </span>
                        <span class="zx-text-tiny" *ngIf="totalOrderdFixProducts() > 1">
                            <span>{{ totalOrderdFixProducts() }}</span>
                            <span>
                                {{ "fix-products.num-of-products.many" | translate }}
                            </span>
                        </span>
                        <span>,</span>
                        <span class="zx-100-opp">.</span>
                        <span class="zx-text-tiny d-flex">
                            <span>{{ totalOrderdFixProductsPrice() }}</span>
                            <span class="zx-100-opp">.</span>
                            <span>{{ "printing-table.nis" | translate }}</span>
                        </span>
                        <span>)</span>
                    </span>
                </span>
            </button>
        </div>

    </div>
</div>